<template>
  <v-col cols="12" md="md">
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
        <tr>
          <th v-for="(value, index) in header" :key="index" class="text-left">
            {{value}}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(item, index) in statistics"
          :key="index"
          :color="item.color"
        >
          <td>{{ item.overview }}</td>
          <td :class="`color-class-${item.color}`">{{ item.yesterday }}</td>
          <td :class="`color-class-${item.color}`">{{ item.today }}</td>
          <td :class="`color-class-${item.color}`">{{ item.day }}</td>
          <td :class="`color-class-${item.color}`">{{ item.month }}</td>
          <td :class="`color-class-${item.color}`">{{ item.year }}</td>
          <td :class="`color-class-${item.color}`">{{ item.sum }}</td>
          <td :class="`color-class-${item.color}`">{{ item.types }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-simple-table class="mt-2" dense>
      <template v-slot:default>
        <thead>
        <tr>
          <th v-for="(value, index) in playoutHeader" :key="index" class="text-left">
            {{value}}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{$t('display/elevator:statistic.table.playouts')}}</td>
          <td class="color-class-pink">{{ getNumber(item.elevatorStatistic.advertisementsLastMondays) }}</td>
          <td class="color-class-pink">{{ getNumber(item.elevatorStatistic.advertisementsLastTuesdays) }}</td>
          <td class="color-class-pink">{{ getNumber(item.elevatorStatistic.advertisementsLastWednesdays) }}</td>
          <td class="color-class-pink">{{ getNumber(item.elevatorStatistic.advertisementsLastThursdays) }}</td>
          <td class="color-class-pink">{{ getNumber(item.elevatorStatistic.advertisementsLastFridays) }}</td>
          <td class="color-class-pink">{{ getNumber(item.elevatorStatistic.advertisementsLastSaturdays) }}</td>
          <td class="color-class-pink">{{ getNumber(item.elevatorStatistic.advertisementsLastSundays) }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-col>
</template>

<script>
export default {
  name: "StatisticField",
  props: {
    item: Object,
    md: String
  },
  data() {
    return {
      playtimeInhouse: 0,
      playtimeFreespace: 0,
      playtimeBudget: 0
    }
  },
  computed: {
    header() {
      return [
        this.$t('display/elevator:statistic.header.overview'),
        this.$t('display/elevator:statistic.header.yesterday'),
        this.$t('display/elevator:statistic.header.today'),
        this.$t('display/elevator:statistic.header.day'),
        this.$t('display/elevator:statistic.header.month'),
        this.$t('display/elevator:statistic.header.year'),
        this.$t('display/elevator:statistic.header.sum'),
        this.$t('display/elevator:statistic.header.types'),
      ];
    },
    statistics() {
      return [
        {
          overview: this.$t('display/elevator:statistic.table.motions'),
          yesterday: this.getNumber(this.item.elevatorStatistic.movementsYesterday),
          today: this.getNumber(this.item.elevatorStatistic.movementsToday),
          day: '',
          month: '',
          year: '',
          sum: this.getNumber(this.item.elevator.ridesTotal),
          types: this.$t('display/elevator:statistic.table.inhouse'),
          color: 'blue'
        },
        {
          overview: 'Ø ' + this.$t('display/elevator:statistic.table.motions'),
          yesterday: '',
          today: '',
          day: this.getNumber(this.item.elevatorStatistic.movementsAverageDay),
          month: this.getNumber(this.item.elevatorStatistic.movementsAverageMonth),
          year: this.getNumber(this.item.elevatorStatistic.movementsAverageYear),
          sum: '',
          types: `${this.getNumber(this.item.elevatorStatistic.movementsAverageYear)} (${this.playtimeInhouse} %) `,
          color: 'blue'
        },
        {
          overview: this.$t('display/elevator:statistic.table.playouts'),
          yesterday: '',
          today: '',
          day: '',
          month: this.getNumber(this.item.elevatorStatistic.advertisementsLast30Days),
          year: '',
          sum: this.getNumber(this.item.elevatorStatistic.advertisementsPlayed),
          types: this.$t('display/elevator:statistic.table.freespace'),
          color: 'pink'
        },
        {
          overview: 'Ø ' + this.$t('display/elevator:statistic.table.playouts'),
          yesterday: '',
          today: '',
          day: this.getNumber(this.item.elevatorStatistic.advertisementsAverageDay),
          month: this.getNumber(this.item.elevatorStatistic.advertisementsAverageMonth),
          year: this.getNumber(this.item.elevatorStatistic.advertisementsAverageYear),
          sum: '',
          types: `${this.getNumber(this.item.elevatorStatistic.playtimeFreespaceYesterday)} (${this.playtimeFreespace} %) `,
          color: 'pink'
        },

        {
          overview: this.$t('display/elevator:statistic.table.revenue'),
          yesterday: this.getNumber(this.item.elevatorStatistic.revenueYesterday),
          today: this.getNumber(this.item.elevatorStatistic.revenueToday),
          day: '',
          month: this.getNumber(this.item.elevatorStatistic.revenueLast30Days),
          year: '',
          sum: this.getNumber(this.item.elevatorStatistic.revenueSum),
          types: this.$t('common:budget'),
          color: 'green'
        },
        {
          overview: 'Ø ' + this.$t('display/elevator:statistic.table.revenue'),
          yesterday: '',
          today: '',
          day: this.getNumber(this.item.elevatorStatistic.revenueAverageDay),
          month: this.getNumber(this.item.elevatorStatistic.revenueAverageMonth),
          year: this.getNumber(this.item.elevatorStatistic.revenueAverageYear),
          sum: '',
          types: `${this.getNumber(this.item.elevatorStatistic.playtimeBudgetYesterday)} (${this.playtimeBudget} %) `,
          color: 'green'
        },

      ];
    },
    playoutHeader() {
      return [
        this.$t('display/elevator:statistic.header.weekdays'),
        this.$t('display/elevator:statistic.header.mon'),
        this.$t('display/elevator:statistic.header.tue'),
        this.$t('display/elevator:statistic.header.wed'),
        this.$t('display/elevator:statistic.header.thu'),
        this.$t('display/elevator:statistic.header.fri'),
        this.$t('display/elevator:statistic.header.sat'),
        this.$t('display/elevator:statistic.header.sun')
      ];
    }
  },

  methods: {
    getNumber(value) {
      if (value == null) {
        return '';
      }
      value = parseFloat(value);
      if (isNaN(value)) {
        return '';
      }
      return value.toLocaleString(undefined, {maximumFractionDigits: 2})
    }
  },
  created() {
    let playtimeInhouse = 0;
    if(this.item.elevatorStatistic.playtimeInhouseYesterday > 0){
      playtimeInhouse =  1.0 * this.item.elevatorStatistic.playtimeInhouseYesterday
        / (this.item.elevatorStatistic.playtimeInhouseYesterday
          + this.item.elevatorStatistic.playtimeFreespaceYesterday
          + this.item.elevatorStatistic.playtimeBudgetYesterday) * 100.0;
    }
    this.playtimeInhouse = this.getNumber(playtimeInhouse);

    let playtimeBudget = 0;
    if(this.item.elevatorStatistic.playtimeBudgetYesterday > 0){
      playtimeBudget =  1.0 * this.item.elevatorStatistic.playtimeBudgetYesterday
        / (this.item.elevatorStatistic.playtimeInhouseYesterday
            + this.item.elevatorStatistic.playtimeFreespaceYesterday
            + this.item.elevatorStatistic.playtimeBudgetYesterday) * 100.0;
    }
    this.playtimeBudget = playtimeBudget;

    let playtimeFreespace = 0;
    if(this.item.elevatorStatistic.playtimeFreespaceYesterday > 0){
      playtimeFreespace =  1.0 * this.item.elevatorStatistic.playtimeFreespaceYesterday
        / (this.item.elevatorStatistic.playtimeInhouseYesterday
            + this.item.elevatorStatistic.playtimeFreespaceYesterday
            + this.item.elevatorStatistic.playtimeBudgetYesterday) * 100.0;
    }
    this.playtimeFreespace = playtimeFreespace;
  }
}
</script>

<style scoped>
  .color-class-blue {
    color: #23afec
  }
  .color-class-pink {
    color: #e2017b;
  }
  .color-class-green {
    color: #20a648;
  }
</style>